import React from "react";

export default ({ data }) => {
  return (
    <div
      className="video-float"
      style={{
        marginTop: "35px",
        marginBottom: "0",
        padding: "0",
        width: "100%",
      }}
    >
      <h4>{data.title}</h4>
      <div className="video-container">
        <iframe
          width="1280"
          height="720"
          src={`//www.youtube.com/embed/${data.youtubeId}?rel=0`}
          frameBorder="0"
          allowFullScreen=""
          title="Video"
        ></iframe>
      </div>
    </div>
  );
};
